import { createFileRoute } from '@tanstack/react-router'
import { GlossaryIndexPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/de/glossar/')({
  loader: () => loadPageData({ data: { kind: 'glossary', locale: 'de' } }),
  head: () => staticRouteHead('glossary', 'de'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <GlossaryIndexPage />
    </CatalogProvider>
  )
}
